import { Pipe, PipeTransform, ElementRef } from "@angular/core";
const PADDING = "000000";

@Pipe({ name: "Percent" })
export class PercentPipe implements PipeTransform {

    private PREFIX: string
    private DECIMAL_SEPARATOR: string;
    private THOUSANDS_SEPARATOR: string;
    private SUFFIX: string

    constructor() {
        // TODO comes from configuration settings
        this.PREFIX = ' %'
        this.DECIMAL_SEPARATOR = ",";
        this.THOUSANDS_SEPARATOR = ".";
        this.SUFFIX = ''
    }


    transform(value: string, fractionSize: number): string {

        if (value) {

            value = value.toString().replace('.', '').replace(this.PREFIX, '')

            value = parseFloat(value.replace(',', '.')).toFixed(fractionSize).replace('.', ',')

            let [integer, fraction = "00"] = (value || "").toString().split(",")

            integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.THOUSANDS_SEPARATOR);

            return integer + this.DECIMAL_SEPARATOR + fraction + this.SUFFIX + this.PREFIX;
        }

        return value


    }

    parse(value: string, fractionSize: number): string {

        value = value.replace(this.PREFIX, '')

        let [integer, fraction = ""] = (value || "").replace(this.PREFIX, "")
            .replace(this.SUFFIX, "")
            .split(this.DECIMAL_SEPARATOR);

        integer = integer.replace(/[^\d]+/g, '')

        fraction = parseInt(fraction, 10) > 0 && fractionSize > 0 ?
            this.DECIMAL_SEPARATOR + (fraction + PADDING).substring(0, fractionSize)
            : "";

        return (integer + fraction)
    }


}